import {Document} from "types/Document";
import {dateTime} from "services/date";
import deserializeFile from "services/ngage/deserializers/file";

/**
 * Transform the given document by deserializing object properties
 *
 * @internal
 * @param document
 */
export default function deserializeDocument(document: any): Document {
    document.asset && (document.asset = deserializeFile(document.asset));
    document.created_at = dateTime(document.created_at);
    document.updated_at = dateTime(document.updated_at);

    return document;
}